export default Object.freeze({
  TITLE: '게시글 이동',
  TH_ONE: '변경 대상 게시글',
  TH_TWO: '게시판 선택',
  TH_THREE: '게시판 카테고리',
  BTN_APPLY: '적용',
  BTN_CANCEL: '취소',
  ALERT_ONE: '게시판을 선택해 주세요',
  ALERT_TWO: '카테고리를 선택해 주세요',
  CATEGORY_NONE: '게시판 카테고리 선택'
});
